import * as SceneUtils from './components/Viewer/utils/sceneUtils';
import * as FlagsModule from './flags/flagsModule';
import * as sceneRenderable from './renderables/sceneRenderable';
import * as multiViewElement from './multiViewElement';
import * as multiViewRendererContext from './multiViewRendererContext';
import * as sceneViewerConfig from './sceneViewerConfig';
import * as sceneViewerContext from './sceneViewerContext';

export * from './components/Viewer/tools/cameraTool';
export * from './components/Viewer/tools/gizmoTypes';
export * from './components/Viewer/tools/selectionTool';
export * from './components/Viewer/tools/transformTool';
export * from './components/Viewer/Viewer';
export * from './domain/geometry/triMeshGrid2';
export * from './domain/scene/logoTypes';
export * from './domain/scene/pieceGeometryCache';
export * from './domain/scene/sceneGeometryCache';
export * from './domain/scene/sceneGeometryModule';
export * from './domain/scene/sceneTypes';
export * from './domain/materialTypes';
export * from './three/objects/filterObjects';
export * from './renderables/gizmo';
export * from './renderables/arrangementGizmo';
export * from './renderer3/meshes/threeBox';
export * from './renderer3/passes/outlineSelectionPass';
export * from './renderer3/passes/threeMainRenderPass';
export { load as loadAvatarGeometry } from './resources/avatarGeometryLoader';
export { load as loadGarmentGeometry } from './resources/garmentGeometryLoader';
export * from './resources/garmentGeometryTypes';
export * from './resources/resourceEvent';
export * from './resources/resourcesContext';
export * from './sceneReconciler/sceneReconciler';
export * from './sceneReconciler/visibilityState';
export * from './theme/themeColors';
export * from './theme/themeTypes';
export * from './utils/cameraUtils';
export * from './rendererTypes';

export type MultiViewElement = multiViewElement.MultiViewElement;
export type MultiViewRendererContext = multiViewRendererContext.MultiViewRendererContext;
export type SceneRenderable = sceneRenderable.SceneRenderable;
export type SceneViewerConfig = sceneViewerConfig.SceneViewerConfig;
export type SceneViewerContext = sceneViewerContext.SceneViewerContext;

export {
  FlagsModule,
  SceneUtils,
  multiViewElement,
  multiViewRendererContext,
  sceneRenderable,
  sceneViewerContext,
};
